import { CourseNames } from "@/Action/api";
import { ImmigrationGurusSvg } from "@/public/images/Svgs/ImmigirationsSvg";
import React, { useEffect, useState, Fragment } from "react";

const CourseCategoryList = ({
  category,
  isSelected,
  handleCourseSelection,
  showMore,
  toggleShowMore,
  index,
}) => {
  const visibleCourses = showMore
    ? category.Data
    : category.Data.slice(0, 3);

  return (
    <div
      className="inner"
      style={{
        display: "flex",
        flexDirection: "column",
        marginTop: index > 0 ? "20px" : "0",
        height: showMore ? "auto" : "200px",
        overflow: "hidden",
      }}
    >
      <h4 className="rbt-widget-title">{category?.Title}</h4>
      <ul
        className="rbt-sidebar-list-wrapper categories-list-check has-show-more-inner-content"
        style={{ margin: 0, padding: 0, overflow: showMore ? "auto" : "" }}
      >
        {category.Data.length > 0 ? (
          visibleCourses.map(({ id, name }, childIndex) => (
            <li
              key={childIndex}
              className="rbt-check-group"
              onClick={() =>
                handleCourseSelection(id, category?.name, { id, name })
              }
            >
              <input
                id={`cat-list-${category?.name}-${id}`}
                type="checkbox"
                name={`cat-list-${category?.name}-${id}`}
                checked={isSelected?.[category?.name]?.includes(id) || false}
                onChange={() =>
                  handleCourseSelection(id, category?.name, { id, name })
                }
              />
              <label htmlFor={`cat-list-${category?.name}-${id}`}>{name}</label>
            </li>
          ))
        ) : (
          <li>No options found</li>
        )}
      </ul>

      <div className={`rbt-show-more-btn ${showMore ? "" : "active"}`}>
        <span onClick={() => toggleShowMore(category?.name)}>
          {!showMore ? "Show More" : "Show Less"}
        </span>
      </div>
    </div>
  );
};

const CourseSidebar = ({ isSelected, setIsSelected, Data = [], onSearch }) => {
  const [show, setShow] = useState(true);
  const [courses, setCourses] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showMoreCategories, setShowMoreCategories] = useState({});
  const [openFilter, setOpenFIlter] = useState(false);

  useEffect(() => {
    const fetchUniversity = async () => {
      try {
        const result = await CourseNames();
        if (result?.res?.success) {
          const newMajorData = result.res.data.map(({ id, name }) => ({
            id,
            name,
          }));
          setCourses(newMajorData);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchUniversity();
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    if (onSearch) onSearch(value);
  };

  const handleCourseSelection = (courseId, categoryName) => {
    setIsSelected((prev) => {
      const currentSelection = prev[categoryName] || [];
      const alreadySelected = currentSelection.includes(courseId);

      return {
        ...prev,
        [categoryName]: alreadySelected
          ? currentSelection.filter((id) => id !== courseId)
          : [...currentSelection, courseId],
      };
    });
  };

  const toggleShowMore = (categoryName) => {
    setShowMoreCategories((prevState) => {
      const newShowMoreState = {
        ...prevState,
        [categoryName]: !prevState[categoryName],
      };

      Object.keys(newShowMoreState).forEach((key) => {
        if (key !== categoryName) {
          newShowMoreState[key] = false;
        }
      });

      return newShowMoreState;
    });
  };

  return (
    <Fragment>
      <div
        style={{
          position: "relative",
        }}
      >
        <div className="d-flex justify-content-end container visible_mobile ">
          <div className="d-flex justify-content-end">
            <div
              className="w-fit"
              onClick={() => {
                setOpenFIlter(!openFilter);
              }}
            >
              {ImmigrationGurusSvg.filterSvgIcon}{" "}
            </div>
          </div>
        </div>
        <div className={`${openFilter && "filter_absolute_design"}`}>
          <aside
            className={`rbt-sidebar-widget-wrapper ${!openFilter && "hiddleVisibility"
              }  `}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div className="rbt-single-widget rbt-widget-search">
              <div className="inner">
                <form className="rbt-search-style-1">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                  />
                  <button className="search-btn" type="button">
                    <i className="feather-search"></i>
                  </button>
                </form>
              </div>
            </div>

            <div
              className={`rbt-single-widget rbt-widget-categories ${show ? "has-show-more" : ""
                }`}
              style={{ flex: 1, overflow: "hidden" }}
            >
              {Data?.map((category, index) => (
                <CourseCategoryList
                  key={index}
                  category={category}
                  isSelected={isSelected}
                  handleCourseSelection={handleCourseSelection}
                  showMore={showMoreCategories[category?.name]}
                  toggleShowMore={toggleShowMore}
                  index={index}
                />
              ))}
            </div>
          </aside>
        </div>
      </div>
    </Fragment>
  );
};

export default CourseSidebar;
